import * as React from 'react';
import { DefaultButton, PrimaryButton } from "@fluentui/react";

interface IPanelFooterComponent {
  onClick: () => void;
  texto?: string;
  texto2?: string;
  onDismiss?: () => void;
  disableButton?: boolean;
  oneButton?: boolean;
}

export const PanelFooter: React.FC<IPanelFooterComponent> = ({
  onClick,
  texto,
  texto2,
  onDismiss,
  disableButton = false,
  oneButton = false,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          justifyItems: "center",
          height: "5%",
          padding: "2opx",
          margin: "20px",
        }}
      >
        <div style={{ display: "flex" }}>
          <PrimaryButton
            onClick={() => {
              onClick();
            }}
            text={!texto ? "Actualizar" : texto}
            disabled={
              disableButton != null && disableButton !== undefined
                ? disableButton
                : false
            }
          />
        </div>
      {!oneButton && (
        <div style={{ display: "flex" }}>
          <DefaultButton
            onClick={() => {
              if (onDismiss) {
                onDismiss();
              }
            }}
            text={!texto2 ? "Cancelar" : texto2}
          />
        </div>
      )}
       
      </div>
    </>
  );
};
